import { create } from 'zustand';
export const useChildrenStore = create()((set, get) => ({
    children: [],
    setChildren: (children) => set(() => ({ children })),
    getChild: (childId) => {
        const { children } = get();
        return children.find((child) => child.id === childId);
    },
}));
